import users from './users.api';
import tenants from "./tenants.api"
import counties from "./counties.api"
import roles from './roles.api'
import sms from './sms.api'
import property_categories from './property_categories.api'
import property_typologies from './property_typologies.api'
import properties from './properties.api'
import property_units from "./property_units.api"
import payments from './payments.api'
import ticket_categories from './ticket_categories.api'
import ticket_channels from './ticket_channels.api'
import ticket_statuses from './ticket_statuses.api'
import tickets from './tickets.api'
import charge_types from './charge_types.api'
import charges from './charges.api'
import tenancies from './tenancies.api'
import bills from './bills.api'
import notification_types from './notification_types.api'
import payment_accounts from './payment_accounts.api'
import transaction_types from "./transaction_types.api";
import modules from './modules.api'
import profile from './profile.api'
import property_statuses from './property_statuses.api'
import user_types from './user_types.api'
import campaigns from './campaigns.api'
import visitors from './visitors.api'
import property_settings from './property_settings.api'
import reports from './reports.api'
import contacts from './contacts.api'
import tenancy from './tenancy.api'
import expense_categories from './expense_categories.api'
import vendors from './vendors.api'
import vendor_categories from './vendor_categories.api'
import expenses from './expenses.api'
import leases from './leases.api'
import lease_templates from './lease_templates.api'
import notifications from './notifications.api'
import settlements from './settlements.api'
import business_invoices from './business-invoices.api'
import landlord_invoices from './landlord-invoices.api'
import plans from './plans.api'
import penalties from './penalties.api'
import penalty_settings from './penalty_settings.api'
import business_settings from './business_settings.api'

export default {
    ...users,
    ...roles,
    ...sms,
    ...tenants,
    ...counties,
    ...property_categories,
    ...property_typologies,
    ...properties,
    ...property_units,
    ...payments,
    ...ticket_categories,
    ...ticket_channels,
    ...ticket_statuses,
    ...tickets,
    ...charge_types,
    ...charges,
    ...tenancies,
    ...bills,
    ...notification_types,
    ...payment_accounts,
    ...transaction_types,
    ...modules,
    ...profile,
    ...property_statuses,
    ...user_types,
    ...campaigns,
    ...visitors,
    ...property_settings,
    ...reports,
    ...contacts,
    ...tenancy,
    ...expense_categories,
    ...vendors,
    ...vendor_categories,
    ...expenses,
    ...leases,
    ...lease_templates,
    ...notifications,
    ...settlements,
    ...business_invoices,
    ...landlord_invoices,
    ...penalties,
    ...penalty_settings,
    ...plans,
    ...business_settings
}
